const colors = {
  // Cor base
  primary: "#F6F6F2", // Branco acinzentado (mantido)
  secondary: "#545454", // Azul suave que complementa o primary
  
  // Cores de status com tons mais sofisticados
  success: "#43AA8B", // Verde elegante
  danger: "#E63946",  // Vermelho refinado
  warning: "#F9A826", // Laranja/amarelo menos saturado
  
  // Tons neutros
  light: "#FFFFFF",   // Branco puro
  dark: "#2F3E46",    // Cinza escuro com tom azulado
  darker: "#1d262b",
  textGray: "#808080", // Adicionado para texto padrão
  
  // Cores complementares adicionais
  accent1: "#E07A5F", // Coral/terroso para destaque
  accent2: "#81B29A", // Verde menta suave
  background: "#F8F9FA" // Fundo sutilmente diferente do primário
};



export default colors;